var htmlDecodeDict = {
  '&quot;': '"',
  '&amp;': '&',
  '&apos;': "'",
  '&lt;': '<',
  '&gt;': '>',
  '&nbsp;': ' ',
  '&#39;': "'"
};
var htmlEncodeDict = {
  '&': '&amp;',
  '"': '&quot;',
  "'": '&apos;',
  '<': '&lt;',
  '>': '&gt;'
};
var decodeKeys = Object.keys(htmlDecodeDict);
var decodeReg = new RegExp("(".concat(decodeKeys.join('|'), ")"), 'g');
var encodeKeys = Object.keys(htmlEncodeDict);
var encodeReg = new RegExp("(".concat(encodeKeys.join('|'), ")"), 'g');
/**
 * decode string
 * @param {string} str 需要 decode 的字符串
 * @return {string} decode 后的字符串
 * @memberof module:Decode-and-Encode
 * @example
 * imutils.decodeHtml('&lt;&quot;666&quot;&gt;&amp;'); // <"666">&
 */

function decodeHtml(str) {
  return str ? str.replace(decodeReg, function (all) {
    return htmlDecodeDict[all];
  }) : str;
}
/**
 * encode string
 * @param {string} str 需要 encode 的字符串
 * @return {string} encode 后的字符串
 * @memberof module:Decode-and-Encode
 * @example
 * imutils.encodeHtml('<"666">&'); // &lt;&quot;666&quot;&gt;&amp;
 */


function encodeHtml(str) {
  return str ? str.replace(encodeReg, function (all) {
    return htmlEncodeDict[all];
  }) : str;
}

export { decodeHtml, encodeHtml };